import "intersection-observer"; // Polyfill
import onDocumentLoaded from "../lib/onDocumentLoaded";

export interface SiteAnimationsConfig {
	observedSelector: string;
	ancestorSelector?: string;
	options: IntersectionObserverInit;
	intersectionRatio?: number;
}

export default class SiteAnimations {
	private config: SiteAnimationsConfig;

	static createInstance(configs: SiteAnimationsConfig[]): SiteAnimations[] {
		const siteAnimations = new Array<SiteAnimations>();
		configs.forEach((config) => {
			siteAnimations.push(new SiteAnimations(config));
		});
		return siteAnimations;
	}
	
	private constructor(config: SiteAnimationsConfig) {
		this.config = config;
		if (this.config.intersectionRatio === undefined) {
			this.config.intersectionRatio = 0;
		}
		onDocumentLoaded(document, () => {
			this.createObserver(config);
		});
	}

	private createObserver(config: SiteAnimationsConfig): void {
		const observerElements: NodeList = document.querySelectorAll(config.observedSelector);
		if (observerElements.length == 0) {
			return;
		}
		
		const observer: IntersectionObserver = new IntersectionObserver(this.onIntersectionObserve, config.options);

		for (let i = 0, l = observerElements.length; i < l; ++i) {
			let element = observerElements[i];
			if (element instanceof HTMLElement) {
				const ancestor = this.getAncestor(element);
				ancestor.setAttribute("data-animation", "setup");
				observer.observe(element);
			}
		}
	}

	private onIntersectionObserve = (entries: Array<IntersectionObserverEntry>, observer: IntersectionObserver) => {
		entries.forEach((entry) => {
			if ((entry.isIntersecting || entry.isIntersecting === undefined) && entry.intersectionRatio >= this.config.intersectionRatio) {
				const element = entry.target;
				const ancestor = this.getAncestor(element);
				observer.unobserve(element);

				/* resolves jank */
				window.requestAnimationFrame(() => {
					ancestor.setAttribute("data-animation", "begin");
				});
			}
		});
	}

	private getAncestor(element: Element): Element {
		if (this.config.ancestorSelector === undefined) {
			return element;
		}

		let ancestors: NodeList = document.querySelectorAll(this.config.ancestorSelector);
		let ancestor: Element = element;

		for (let i = 0, l = ancestors.length; i < l; ++i) {
			let element = ancestors[i] as Element;
			if (element.contains(element)) {
				ancestor = element as Element;
			}
		}
		return ancestor;
	}
}